import alertsMenuItems from './alerts';
import contactsMenuItems from './contacts';
import incidentManagementMenuItems from './incidentManagement';
import reportsMenuItems from './reports';
import subscriptionsMenuItems from './subscriptions';
import supportAndTrainingMenuItems from './supportAndTraining';
import dashboardMenuItems from './dashboard';
import settingsMenuItems from './settings';
import configureMenuItems from './configure';
import schedulesMenuItem from './schedules';
import placesMenuItems from './places';
import riskIntelligenceMenuItems from './riskIntelligence';

const menuItems = [
    dashboardMenuItems,
    alertsMenuItems,
    contactsMenuItems,
    schedulesMenuItem,
    placesMenuItems,
    reportsMenuItems,
    incidentManagementMenuItems,
    subscriptionsMenuItems,
    configureMenuItems,
    settingsMenuItems,
    supportAndTrainingMenuItems,
    riskIntelligenceMenuItems
];

export { menuItems };
